export const COUNT_BINS_MAX = 60;
export const COUNT_AIRBAG_MAX = 6000;
